import EcommerceChangesPeriod from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceChangesPeriod";
import EcommerceChangesTrend from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceChangesTrend";

import { normalizeDirectionForForm, normalizePeriodForForm } from "./ecommerceFilterNormalization";

const DEFAULT_DIRECTIONS: readonly EcommerceChangesTrend[] = [
    EcommerceChangesTrend.Grew,
    EcommerceChangesTrend.Declined,
];

const DEFAULT_PERIODS: readonly EcommerceChangesPeriod[] = [
    EcommerceChangesPeriod.MonthOverMonth,
    EcommerceChangesPeriod.QuoterOverQuoter,
    EcommerceChangesPeriod.YearOverYear,
];

export function mapEcommerceDirectionOptions(raw: readonly string[] | undefined): readonly EcommerceChangesTrend[] {
    if (typeof raw === "undefined" || raw.length === 0) {
        return DEFAULT_DIRECTIONS;
    }

    const unique = new Set<EcommerceChangesTrend>();

    raw.forEach((item) => {
        const mapped = normalizeDirectionForForm(item);

        if (typeof mapped !== "undefined") {
            unique.add(mapped);
        }
    });

    return unique.size > 0 ? [...unique] : DEFAULT_DIRECTIONS;
}

export function mapEcommercePeriodOptions(raw: readonly string[] | undefined): readonly EcommerceChangesPeriod[] {
    if (typeof raw === "undefined" || raw.length === 0) {
        return DEFAULT_PERIODS;
    }

    const unique = new Set<EcommerceChangesPeriod>();

    raw.forEach((item) => {
        const mapped = normalizePeriodForForm(item);

        if (typeof mapped !== "undefined") {
            unique.add(mapped);
        }
    });

    return unique.size > 0 ? [...unique] : DEFAULT_PERIODS;
}
